import React from 'react';
import './RegisterDoktorLeftSide.css';

const RegisterDoktorLeftSide = () => {
    return (
        <section className="register-doktor-left-section">
            <p className='base-metin'>Uygun resimler ya da kurumsal bir <a href='deneme'>illüstrasyon</a></p>
            <p className='doktor-metin'>Doktor / Terapist</p>
        </section>
    );
};

export default RegisterDoktorLeftSide;
